var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2810772ccc9865d45ee1d849fdb13310cb7200d1"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["website-next@upflow"]={id:"2810772ccc9865d45ee1d849fdb13310cb7200d1"};
      